<template>
  <div class="node-container">
    <div class="node" :class="nodeName" :style="nodeStyle" :ref="nodeName">
      <span class="info">【{{ source.id }}】{{ source.nickname }}</span><span class="job-title" :style="{backgroundColor: getTitle(source.level).color}">{{getTitle(source.level).name}}</span>
    </div>

    <div v-if="source.child.length > 0" class="node-inner">
      <SelfComponent
        v-for="child in source.child"
        :key="child.id"
        :source="child"
        :index="index + 1"
        :nodeWidth="nodeWidth"
        :parentRef="nodeName"></SelfComponent>
      <div v-if="source.child.length > 1" class="link-line" :style="linkLineStyle"></div>
    </div>
  </div>
</template>

<script>

// 3 总监
// 2 经理
// 1 顾问
import { v4 as uuidv4 } from 'uuid';
export default {
  name: "SelfComponent",
  props: {
    source: Object,
    index: {
      type: Number,
      default: 1
    },
    parentRef: String,
    nodeWidth: Number
  },
  data() {
    return {
      uuid: uuidv4(),
      linkLine: {},
      nodeOffsetDistance: 0
    };
  },
  computed: {
    nodeName() {
      return `node-${this.index}-${this.uuid}`
    },
    linkLineStyle() {
      return {
        top: `-20px`,
        left: `${this.linkLine.left}px`,
        // right: `${this.linkLine.right}px`,
        width: `${this.linkLine.width}px`,
        // transform: `rotate(${this.linkLine.angel}deg)`
      }
    },
    nodeStyle() {
      return {
        width: `${this.nodeWidth}px`,
        marginLeft: `${this.nodeOffsetDistance}px`,
      }
    }
  },
  created() {},
  mounted() {
    this.initNode()
  },
  methods: {
    getTitle(level) {
      const titleArray = ["顾问", "经理", "总监"]
      const colorArray = ["#1890FF", "#FA841C", "#D54B53"]

      return {
        name: titleArray[level - 1],
        color: colorArray[level - 1],
      }
    },
    initNode() {
      if(this.source.child.length <= 1) return

      const firstEl = this.$children[0].$el
      const lastEl = this.$children[this.$children.length - 1].$el
      const firstElLeft = firstEl.offsetLeft + firstEl.firstChild.offsetLeft + this.nodeWidth / 2
      const lastElLeft = lastEl.offsetLeft + lastEl.firstChild.offsetLeft + this.nodeWidth / 2
      const length = lastElLeft - firstElLeft
      
      this.linkLine = {
        left: firstElLeft,
        width: length
      }

      const realLength = length - (this.source.child.length - 1) * 40
      const realCount = realLength / this.nodeWidth

      if(realCount.toString().split(".")[1]?.length > 0){
        const shouldLeft = this.linkLine.left + length / 2
        const currentLeft = this.$refs[this.nodeName].offsetLeft + this.nodeWidth / 2
        this.nodeOffsetDistance = (shouldLeft - currentLeft) * 2
      }




      // ----------------------------------
      // 
      // if (this.parentRef) {
      //   const parentEl = this.$parent.$refs[this.parentRef]
      //   const currentEl = this.$refs[this.nodeName]
      //   const parentElRect = parentEl.getBoundingClientRect()
      //   const currentElRect = currentEl.getBoundingClientRect()
      //   console.log("-----");
      //   console.log('parent', this.$parent);
      //   console.log('current', currentEl);

      //   this.linkLine = this.createLine([
      //     {
      //       x: parentEl.offsetLeft,
      //       y: parentEl.offsetTop,
      //       width: parentEl.offsetWidth,
      //       height: parentEl.offsetHeight
      //     },
      //     {
      //       x: currentEl.offsetLeft,
      //       y: currentEl.offsetTop,
      //       width: currentEl.offsetWidth,
      //       height: currentEl.offsetHeight 
      //     },
      //   ])
      // }

    },
    createLine(params) {
      const [startObj, endObj] = params

      // 起点坐标
      const startX = startObj.x + startObj.width / 2;
      const startY = startObj.y + startObj.height;

      // 终点坐标
      const endX = endObj.x + endObj.width / 2;
      const endY = endObj.y;

      // 用勾股定律计算出斜边长度及其夹角（即连线的旋转角度）
      const lx = endX - startX;
      const ly = endY - startY;
      // 计算连线长度
      const length = Math.sqrt(lx * lx + ly * ly);
      // 弧度值转换为角度值
      const c = 360 * Math.atan2(ly, lx) / (2 * Math.PI);

      // 连线中心坐标
      const midX = (endX + startX) / 2;
      const midY = (endY + startY) / 2
      const deg = c <= -90 ? (360 + c) : c; // 负角转换为正角

      return {
        y: midY, x: midX - length / 2, width: length, angel: deg
      }
    },
    createLine0(params) {
      const [startObj, endObj] = params

      // 起点坐标
      const startX = startObj.x + startObj.width / 2;
      const startY = startObj.y + startObj.height;

      // 终点坐标
      const endX = endObj.x + endObj.width / 2;
      const endY = endObj.y;

      // 用勾股定律计算出斜边长度及其夹角（即连线的旋转角度）
      const lx = endX - startX;
      const ly = endY - startY;
      // 计算连线长度
      const length = Math.sqrt(lx * lx + ly * ly);
      // 弧度值转换为角度值
      const c = 360 * Math.atan2(ly, lx) / (2 * Math.PI);

      // 连线中心坐标
      const midX = (endX + startX) / 2;
      const midY = (endY + startY) / 2
      const deg = c <= -90 ? (360 + c) : c; // 负角转换为正角

      return {
        y: midY, x: midX - length / 2, width: length, angel: deg
      }
    },
    createLine1(dots) {
      return dots.map((dot, index) => {
        // 最后一个点没有连线
        if (!dots[index + 1]) return;
        const AB = {
          x: dots[index + 1].x - dot.x,
          y: dots[index + 1].y - dot.y,
        }
        const BC = {
          x: 0,
          y: 1,
        }

        // 向量的模
        const a = Math.sqrt(Math.pow(AB.x, 2) + Math.pow(AB.y, 2));
        const b = Math.sqrt(Math.pow(BC.x, 2) + Math.pow(BC.y, 2));


        const aXb = (AB.x * BC.x) + (AB.y * BC.y);
        const cos_ab = aXb / (a * b);

        // 求出偏转角度
        const angle_1 = Math.acos(cos_ab) * (180 / Math.PI);

        // 10 是点的半径, 根据点的大小修改
        return {
          x: dot.x + 10,
          y: dot.y + 10,
          width: a,
          angel: AB.x > 0 ? Math.sqrt(Math.pow(angle_1, 2)) - 270 : -Math.sqrt(Math.pow(angle_1, 2)) - 270
        }
      }).filter(item => !!item)[0]
    },
  }
};
</script>
<style scoped>
.node-container {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.node-container:not(:first-child){
  margin-left: 40px;
}

.node {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 45px;
  line-height: 45px;
  /* font-size: 19px; */
  border-radius: 45px;
  white-space: nowrap;
  position: relative;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 1px rgba(0,0,0,0.11);
}
.node > .info{
  flex-shrink: 0;
  flex-grow: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  color: #333333;
  font-size: 19px;
}

.node > .job-title{
  flex-shrink: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 73px;
  height: 45px;
  border-radius: 45px;
  color: white;
  font-size: 23px;
  box-shadow: 0px 4px 8px 1px rgba(0,0,0,0.11);
  border: 3px solid #FFFFFF;

}

.node-inner {
  margin-top: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;
}

.node-inner>.node-container:not(:first-child){
  margin-left: 40px;
}

/* .link-line {
  position: absolute;
  left: 70px;
  right: 70px;
  height: 2px;
  background-color: green;
} */

.node-container > .node::before{
  box-sizing: border-box;
  content: "";
  display: block;
  width: 1px;
  height: 20px;
  /* background-color: red; */
  border-left: 2px solid #999999;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -20px;
}
.node-container > .node:not(:last-child)::after{
  box-sizing: border-box;
  content: "";
  display: block;
  width: 1px;
  height: 20px;
  /* background-color: red; */
  border-left: 2px solid #999999;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -20px;
}
</style>